import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import ContentSections from './components/ContentSections';
import SeoArticlesSection from './components/SeoArticlesSection';
import Footer from './components/Footer';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://oopbuyspread.wiki';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'OOPBuy Spreadsheet',
  url: SITE_URL,
  description:
    'Entdecke den kompletten OOPBuy Spreadsheet Guide. Produkte finden, Kategorien vergleichen, QC Fotos verstehen und sicher bestellen.',
  inLanguage: 'de',
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'OOPBuy Spreadsheet',
  url: SITE_URL,
  description:
    'Die grösste deutsche OOPBuy Spreadsheet Wissensplattform – unabhängige Informationsplattform für OOPBuy Nutzer.',
  sameAs: ['https://kaspreadsheet.com'],
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <ContentSections />
        <SeoArticlesSection />
      </main>
      <Footer />
    </div>
  );
}